import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getCompanyDashboard } from '../../api/dashboardApi';
import CompanyDashboardView from './templates/CompanyDashboardView';
import './templates/DashboardTemplates.css';

const CompanyDashboardShell = ({ companyId, persistCompany = true }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!companyId) return;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await getCompanyDashboard(companyId);
        setData(response);
        if (persistCompany) {
          localStorage.setItem('last_company_id', String(companyId));
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to load dashboard.';
        setError(msg);
        toast.error(msg);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [companyId, persistCompany]);

  if (loading) {
    return <div className="cd-loading">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="cd-error">{error}</div>;
  }

  if (!data) {
    return <div className="cd-empty">No dashboard data available.</div>;
  }

  return <CompanyDashboardView data={data} />;
};

export default CompanyDashboardShell;
